module.exports = __webpack_public_path__ + "img/cover_T950.39a663b7.png";